import React from 'react'
import { View, ActivityIndicator } from 'react-native'

export default props => (
  <View style={{ paddingTop: 30 }}>
    <ActivityIndicator color="#fff" />
  </View>
)
